// extracted by mini-css-extract-plugin
export default {"confirmOverlay":"AccionaConfirm_confirmOverlay__a1uj7","confirmBox":"AccionaConfirm_confirmBox__No-hf","footer":"AccionaConfirm_footer__Z-mhL"};